import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserModel } from '../models/user.model';

@Injectable()
export class UserService {

    constructor(
        private http: HttpClient,
        @Inject('API_BASE_URL') private baseUrl: string) { }

    search(searchTerm: string, searchType: string, page: number, pageSize: number): Observable<Object> {
        let url = this.baseUrl + 'users/search';
        let query = {
            searchTerm: searchTerm,
            page: page,
            pageSize: pageSize,
            searchType: searchType
        };        
        return this.http.post(url, query);
    }

    get(id: string): Promise<UserModel> {
        const url = this.baseUrl + 'users/' + id;

        let promise = new Promise<UserModel>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as UserModel);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not get user"
                    });
                });
        });

        return promise;
    }

    create(model: any): Promise<UserModel> {
        const url = this.baseUrl + 'users';

        let promise = new Promise<UserModel>((resolve, reject) => {
            this.http.post(url, model)
                .toPromise()
                .then(res => {
                    var data = (res as UserModel);
                    resolve(data);
                })
                .catch(reason => {
                    // handle email errors differently in case it's a conflict.
                    if (reason.error && reason.error.Email) {
                        reject({
                            status: reason.status,
                            description: reason.error.Email[0]
                        });
                    }
                    else {
                        reject({
                            status: reason.status,
                            description: "Could not save user"
                        });
                    }
                });
        });

        return promise;
    }

    recreate(id: string, model: any): Promise<UserModel> {
        const url = `${this.baseUrl}users/recreate/${id}`;

        let promise = new Promise<UserModel>((resolve, reject) => {
            this.http.put(url, model)
                .toPromise()
                .then(res => {
                    var data = (res as UserModel);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not recreate user"
                    });
                });
        });

        return promise;
    }

    recover(id: string): Promise<UserModel> {
        const url = `${this.baseUrl}users/recover/${id}`;

        let promise = new Promise<UserModel>((resolve, reject) => {
            this.http.post(url, {})
                .toPromise()
                .then(res => {
                    var data = (res as UserModel);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not update user"
                    });
                });
        });

        return promise;
    }

    update(id: string, model: any): Promise<UserModel> {
        const url = `${this.baseUrl}users/update/${id}`;

        let promise = new Promise<UserModel>((resolve, reject) => {
            this.http.put(url, model)
                .toPromise()
                .then(res => {
                    var data = (res as UserModel);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "Could not update user"
                    });
                });
        });

        return promise;
    }
}
